var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInputBarUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5680",
    "data-name": "Rectangle 5680",
    width: 25.099,
    height: 26.176,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-input-bar-upload",
    transform: "translate(-366 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5672",
    "data-name": "Rectangle 5672",
    width: 29,
    height: 30,
    transform: "translate(366 352)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7239",
    "data-name": "Group 7239",
    transform: "translate(367.988 353.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7002",
    "data-name": "Group 7002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M18.609,7.945,12.1,1,5.583,7.945",
    transform: "translate(0.451 0.081)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_438",
    "data-name": "Line 438",
    y1: 17.653,
    transform: "translate(12.549 1.081)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M1,14.342v5.933a3.66,3.66,0,0,0,3.661,3.661H20.277a3.66,3.66,0,0,0,3.661-3.661V14.342",
    transform: "translate(0.081 1.159)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputBarUpload);
export default __webpack_public_path__ + "static/media/icon-input-bar-upload.ba060fa33c94a75093258c23e091f5b6.svg";
export { ForwardRef as ReactComponent };